module.exports = __webpack_public_path__ + "media/country_flags/bq-e21601d6.png";